"use strict";
/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStepGroups = void 0;
var reduceSingleStepInStepGroup_1 = require("./reduceSingleStepInStepGroup");
var reduceLastStepInStepGroup_1 = require("./reduceLastStepInStepGroup");
var reduceFirstStepInStepGroup_1 = require("./reduceFirstStepInStepGroup");
var reduceMiddleStepInStepGroup_1 = require("./reduceMiddleStepInStepGroup");
var utils_1 = require("./utils");
var utils_2 = require("../../../utils");
var getStepGroups = function (formatSyntaxTree, steps, config) {
    return steps.reduce((0, utils_2.choose)((0, utils_1.shouldStepBeLastStepInStepGroup)(config), (0, utils_2.choose)(utils_1.isStepFirstStepInStepGroup, (0, reduceSingleStepInStepGroup_1.default)(formatSyntaxTree, config), (0, reduceLastStepInStepGroup_1.default)(formatSyntaxTree, config)), (0, utils_2.choose)(utils_1.isStepFirstStepInStepGroup, (0, reduceFirstStepInStepGroup_1.default)(formatSyntaxTree, config), (0, reduceMiddleStepInStepGroup_1.default)(formatSyntaxTree, config))), {
        stepsInStepGroup: [],
        stepGroups: [],
    }).stepGroups;
};
exports.getStepGroups = getStepGroups;
